<form [formGroup]="dripAutomationForm" autocomplete="off">
  <ng-container *ngIf="isAllowManageNumberFeature">
    <div class="form-group">
      <div class="re-agent-radiosec">
        <p class="re-agent-radotext">
          Auto assign a Drip to leads created under this campaign?
        </p>
        <label class="re-agent-switch">
          <input
            type="checkbox"
            id="dripcamp"
            formControlName="isAutoAssignDrip"
            (change)="onAutoAssignDrip()"
          />
          <span class="re-agent-slider"></span>
          <span value="false" class="re-agent-text1">No</span>
          <span value="true" class="re-agent-text2">Yes</span>
        </label>
      </div>
      <hr />
    </div>

    <div
      class="re-agent-tasks-cont"
      *ngIf="dripAutomationForm?.value?.isAutoAssignDrip"
    >
      <div class="re-agent-tasktitle">
        <a href="javascript:void(0)" (click)="toggleSection('leadManually')">
          <span class="re-agent-name-txt">Leads created manually</span>
          <span class="re-agent-arrows" *ngIf="!isVisible('leadManually')">
            <i
              class="fa fa-chevron-circle-up re-agent-teals"
              aria-hidden="true"
            ></i>
          </span>
          <span class="re-agent-arrows" *ngIf="isVisible('leadManually')">
            <i
              class="fa fa-chevron-circle-down re-agent-blacks"
              aria-hidden="true"
            ></i>
          </span>
        </a>
      </div>

      <div class="row pb-3" [class.collapse]="isVisible('leadManually')">
        <div class="col-12 col-md-12">
          <div class="re-agent-radiosec">
            <p class="re-agent-radotext">Would you like to enable this</p>
            <label class="re-agent-switch">
              <input
                type="checkbox"
                id="leadcreate"
                formControlName="isLeadCreatedManual"
                (change)="onLeadCreatedManual()"
              />
              <span class="re-agent-slider"></span>
              <span value="false" class="re-agent-text1">Off</span>
              <span value="true" class="re-agent-text2">On</span>
            </label>
          </div>
          <div *ngIf="dripAutomationForm?.value?.isLeadCreatedManual">
            <div class="form-group">
              <label class="labels">Choose auto follow-up sequence * </label>
              <select
                class="form-control"
                formControlName="manualLeadDripId"
                (change)="onLeadCreatedManual()"
              >
                <option value="null">--Select drip campaign sequence--</option>
                <option *ngFor="let drip of dripList" value="{{ drip._id }}">
                  {{ drip.name }}
                </option>
              </select>
            </div>

            <div class="re-agent-radiosec">
              <p class="re-agent-radotext">
                Would you like to stop the drip campaign once you receive a Call
                or SMS from the lead?
              </p>
              <div class="re-radiolist">
                <label class="re-radiobtn">
                  <input
                    type="radio"
                    name="isManualLeadAutoStopDrip"
                    [value]="true"
                    formControlName="isManualLeadAutoStopDrip"
                    id="inlineRadio1"
                    (change)="callEmitForm()"
                  />
                  <div
                    class="form-check-label re-agent-no-margin"
                    for="inlineRadio1"
                  >
                    Yes
                  </div>
                  <span class="re-checkmark"></span>
                </label>
                <label class="re-radiobtn">
                  <input
                    type="radio"
                    name="isManualLeadAutoStopDrip"
                    [value]="false"
                    formControlName="isManualLeadAutoStopDrip"
                    id="inlineRadio2"
                    (change)="callEmitForm()"
                  />
                  <div
                    class="form-check-label re-agent-no-margin"
                    for="inlineRadio2"
                  >
                    No
                  </div>
                  <span class="re-checkmark"></span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--Unanswered-->
    <div
      class="re-agent-tasks-cont"
      *ngIf="dripAutomationForm?.value?.isAutoAssignDrip"
    >
      <div class="re-agent-tasktitle">
        <a href="javascript:void(0)" (click)="toggleSection('leadUnAnswered')">
          <span class="re-agent-name-txt"
            >Leads created from incoming UN-ANSWERED calls</span
          >
          <span class="re-agent-arrows" *ngIf="!isVisible('leadUnAnswered')">
            <i
              class="fa fa-chevron-circle-up re-agent-teals"
              aria-hidden="true"
            ></i>
          </span>
          <span class="re-agent-arrows" *ngIf="isVisible('leadUnAnswered')">
            <i
              class="fa fa-chevron-circle-down re-agent-blacks"
              aria-hidden="true"
            ></i>
          </span>
        </a>
      </div>
      <div class="row pb-3" [class.collapse]="isVisible('leadUnAnswered')">
        <div class="col-12 col-md-12">
          <div class="re-agent-radiosec">
            <p class="re-agent-radotext">Would you like to enable this</p>
            <label class="re-agent-switch">
              <input
                type="checkbox"
                id="leadCreateunans"
                formControlName="isDripUnansCall"
                (change)="onDripUnansCall()"
              />
              <span class="re-agent-slider"></span>
              <span value="false" class="re-agent-text1">Off</span>
              <span value="true" class="re-agent-text2">On</span>
            </label>
          </div>

          <div *ngIf="dripAutomationForm?.value?.isDripUnansCall">
            <div class="form-group">
              <label class="labels">Choose auto follow-up sequence * </label>
              <select
                class="form-control"
                formControlName="unansDripId"
                (change)="onDripUnansCall()"
              >
                <option value="null">--Select drip campaign sequence--</option>
                <option *ngFor="let drip of dripList" value="{{ drip._id }}">
                  {{ drip.name }}
                </option>
              </select>
            </div>
            <div class="re-agent-radiosec">
              <p class="re-agent-radotext">
                Would you like to stop the drip campaign once you receive a Call
                or SMS from the lead?
              </p>
              <div class="re-radiolist">
                <label class="re-radiobtn">
                  <input
                    type="radio"
                    name="isUnansAutoStopDrip"
                    [value]="true"
                    formControlName="isUnansAutoStopDrip"
                    id="inlineRadio1"
                    (change)="callEmitForm()"
                  />
                  <div
                    class="form-check-label re-agent-no-margin"
                    for="inlineRadio1"
                  >
                    Yes
                  </div>
                  <span class="re-checkmark"></span>
                </label>
                <label class="re-radiobtn">
                  <input
                    type="radio"
                    name="isUnansAutoStopDrip"
                    [value]="false"
                    formControlName="isUnansAutoStopDrip"
                    id="inlineRadio2"
                    (change)="callEmitForm()"
                  />
                  <div
                    class="form-check-label re-agent-no-margin"
                    for="inlineRadio2"
                  >
                    No
                  </div>
                  <span class="re-checkmark"></span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--Answered-->
    <div
      class="re-agent-tasks-cont"
      *ngIf="dripAutomationForm?.value?.isAutoAssignDrip"
    >
      <div class="re-agent-tasktitle">
        <a href="javascript:void(0)" (click)="toggleSection('leadAnswered')">
          <span class="re-agent-name-txt">
            Leads created from incoming ANSWERED calls
          </span>
          <span class="re-agent-arrows" *ngIf="!isVisible('leadAnswered')">
            <i
              class="fa fa-chevron-circle-up re-agent-teals"
              aria-hidden="true"
            ></i>
          </span>
          <span class="re-agent-arrows" *ngIf="isVisible('leadAnswered')">
            <i
              class="fa fa-chevron-circle-down re-agent-blacks"
              aria-hidden="true"
            ></i>
          </span>
        </a>
      </div>
      <div class="row pb-3" [class.collapse]="isVisible('leadAnswered')">
        <div class="col-12 col-md-12">
          <div class="re-agent-radiosec">
            <p class="re-agent-radotext">Would you like to enable this</p>
            <label class="re-agent-switch">
              <input
                type="checkbox"
                id="leadcreateans"
                formControlName="isDripAnsCall"
                (change)="onDripAnsCall()"
              />
              <span class="re-agent-slider"></span>
              <span value="false" class="re-agent-text1">Off</span>
              <span value="true" class="re-agent-text2">On</span>
            </label>
          </div>
          <div *ngIf="dripAutomationForm?.value?.isDripAnsCall">
            <div class="form-group">
              <label class="labels">Choose auto follow-up sequence * </label>
              <select
                class="form-control"
                formControlName="ansDripId"
                (change)="onDripAnsCall()"
              >
                <option value="null">--Select drip campaign sequence--</option>
                <option *ngFor="let drip of dripList" value="{{ drip._id }}">
                  {{ drip.name }}
                </option>
              </select>
            </div>
            <div class="re-agent-radiosec">
              <p class="re-agent-radotext">
                Would you like to stop the drip campaign once you receive a Call
                or SMS from the lead?
              </p>
              <div class="re-radiolist">
                <label class="re-radiobtn">
                  <input
                    type="radio"
                    name="isAnsAutoStopDrip"
                    [value]="true"
                    formControlName="isAnsAutoStopDrip"
                    id="inlineRadio1"
                    (change)="callEmitForm()"
                  />
                  <div
                    class="form-check-label re-agent-no-margin"
                    for="inlineRadio1"
                  >
                    Yes
                  </div>
                  <span class="re-checkmark"></span>
                </label>
                <label class="re-radiobtn">
                  <input
                    type="radio"
                    name="isAnsAutoStopDrip"
                    [value]="false"
                    formControlName="isAnsAutoStopDrip"
                    id="inlineRadio2"
                    (change)="callEmitForm()"
                  />
                  <div
                    class="form-check-label re-agent-no-margin"
                    for="inlineRadio2"
                  >
                    No
                  </div>
                  <span class="re-checkmark"></span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--Integration-->
    <div
      class="re-agent-tasks-cont"
      *ngIf="dripAutomationForm?.value?.isAutoAssignDrip"
    >
      <div class="re-agent-tasktitle">
        <a href="javascript:void(0)" (click)="toggleSection('leadIntegration')">
          <span class="re-agent-name-txt">
            Leads created from integration(Zapier, Carrot, etc.)
          </span>
          <span class="re-agent-arrows" *ngIf="!isVisible('leadIntegration')">
            <i
              class="fa fa-chevron-circle-up re-agent-teals"
              aria-hidden="true"
            ></i>
          </span>
          <span class="re-agent-arrows" *ngIf="isVisible('leadIntegration')">
            <i
              class="fa fa-chevron-circle-down re-agent-blacks"
              aria-hidden="true"
            ></i>
          </span>
        </a>
      </div>
      <div class="row pb-3" [class.collapse]="isVisible('leadIntegration')">
        <div class="col-12 col-md-12">
          <div class="re-agent-radiosec">
            <p class="re-agent-radotext">Would you like to enable this</p>
            <label class="re-agent-switch">
              <input
                type="checkbox"
                id="leadCreatezap"
                formControlName="isDripZap"
                (change)="onDripZap()"
              />
              <span class="re-agent-slider"></span>
              <span value="false" class="re-agent-text1">Off</span>
              <span value="true" class="re-agent-text2">On</span>
            </label>
          </div>

          <div *ngIf="dripAutomationForm?.value?.isDripZap">
            <div class="form-group">
              <label class="labels">Choose auto follow-up sequence * </label>
              <select
                class="form-control"
                formControlName="zapDripId"
                (change)="onDripZap()"
              >
                <option value="null">--Select drip campaign sequence--</option>
                <option *ngFor="let drip of dripList" value="{{ drip._id }}">
                  {{ drip.name }}
                </option>
              </select>
            </div>
            <div class="re-agent-radiosec">
              <p class="re-agent-radotext">
                Would you like to stop the drip campaign once you receive a Call
                or SMS from the lead?
              </p>
              <div class="re-radiolist">
                <label class="re-radiobtn">
                  <input
                    type="radio"
                    name="isZapAutoStopDrip"
                    [value]="true"
                    formControlName="isZapAutoStopDrip"
                    id="inlineRadio1"
                    (change)="callEmitForm()"
                  />
                  <div
                    class="form-check-label re-agent-no-margin"
                    for="inlineRadio1"
                  >
                    Yes
                  </div>
                  <span class="re-checkmark"></span>
                </label>
                <label class="re-radiobtn">
                  <input
                    type="radio"
                    name="isZapAutoStopDrip"
                    [value]="false"
                    formControlName="isZapAutoStopDrip"
                    id="inlineRadio2"
                    (change)="callEmitForm()"
                  />
                  <div
                    class="form-check-label re-agent-no-margin"
                    for="inlineRadio2"
                  >
                    No
                  </div>
                  <span class="re-checkmark"></span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--Web form-->
    <div
      class="re-agent-tasks-cont"
      *ngIf="dripAutomationForm?.value?.isAutoAssignDrip"
    >
      <div class="re-agent-tasktitle">
        <a href="javascript:void(0)" (click)="toggleSection('leadWebForm')">
          <span class="re-agent-name-txt">Leads created from Web Forms</span>
          <span class="re-agent-arrows" *ngIf="!isVisible('leadWebForm')">
            <i
              class="fa fa-chevron-circle-up re-agent-teals"
              aria-hidden="true"
            ></i>
          </span>
          <span class="re-agent-arrows" *ngIf="isVisible('leadWebForm')">
            <i
              class="fa fa-chevron-circle-down re-agent-blacks"
              aria-hidden="true"
            ></i>
          </span>
        </a>
      </div>
      <div class="row pb-3" [class.collapse]="isVisible('leadWebForm')">
        <div class="col-12 col-md-12">
          <div class="re-agent-radiosec">
            <p class="re-agent-radotext">Would you like to enable this</p>
            <label class="re-agent-switch">
              <input
                type="checkbox"
                id="leadCreateWebForm"
                formControlName="isDripWebForm"
                (change)="onDripWebForm()"
              />
              <span class="re-agent-slider"></span>
              <span value="false" class="re-agent-text1">Off</span>
              <span value="true" class="re-agent-text2">On</span>
            </label>
          </div>

          <div *ngIf="dripAutomationForm?.value?.isDripWebForm">
            <div class="form-group">
              <label class="labels">Choose auto follow-up sequence * </label>
              <select
                class="form-control"
                formControlName="webFormDripId"
                (change)="onDripWebForm()"
              >
                <option value="null">--Select drip campaign sequence--</option>
                <option *ngFor="let drip of dripList" value="{{ drip._id }}">
                  {{ drip.name }}
                </option>
              </select>
            </div>
            <div class="re-agent-radiosec">
              <p class="re-agent-radotext">
                Would you like to stop the drip campaign once you receive a Call
                or SMS from the lead?
              </p>
              <div class="re-radiolist">
                <label class="re-radiobtn">
                  <input
                    type="radio"
                    name="isWebFormAutoStopDrip"
                    [value]="true"
                    formControlName="isWebFormAutoStopDrip"
                    id="inlineRadio1"
                    (change)="callEmitForm()"
                  />
                  <div
                    class="form-check-label re-agent-no-margin"
                    for="inlineRadio1"
                  >
                    Yes
                  </div>
                  <span class="re-checkmark"></span>
                </label>
                <label class="re-radiobtn">
                  <input
                    type="radio"
                    name="isWebFormAutoStopDrip"
                    [value]="false"
                    formControlName="isWebFormAutoStopDrip"
                    id="inlineRadio2"
                    (change)="callEmitForm()"
                  />
                  <div
                    class="form-check-label re-agent-no-margin"
                    for="inlineRadio2"
                  >
                    No
                  </div>
                  <span class="re-checkmark"></span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <div
    class="re-agent-unauthorized"
    *ngIf="isAllowManageNumberFeature == false"
  >
    <img
      class="img-fluid"
      src="assets/images/unauthrozied.png"
      alt="unauthrozied"
    />
    <h4>Upgrade Your Account</h4>
    <div class="re-agent-text">
      Automations are only available on <u>Pro</u> and <u>Enterprise</u> plans.
      <u>Automate your leads follow ups</u> by upgrading your plan.
    </div>
  </div>
</form>
